import { render, staticRenderFns } from "./dragon-info-pannel.vue?vue&type=template&id=9674aab6&scoped=true&"
import script from "./dragon-info-pannel.vue?vue&type=script&lang=js&"
export * from "./dragon-info-pannel.vue?vue&type=script&lang=js&"
import style0 from "./dragon-info-pannel.vue?vue&type=style&index=0&id=9674aab6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9674aab6",
  null
  
)

export default component.exports